export default {
    instructionCenter: {
        title: 'AI 指令库',
        searchPlaceholder: '搜索指令...',
        gridView: '网格视图',
        listView: '列表视图',
        createInstruction: '创建指令',
        noInstructions: '暂无指令',
        noInstructionsDesc: '点击"创建指令"按钮添加您的第一个指令',
        loading: '加载中',
        loadMore: '加载更多',
        preview: '预览',
        edit: '编辑',
        delete: '删除',
        cancel: '取消',
        save: '保存',
        saving: '保存中',
        moreActions: '更多操作',
        editInstruction: '编辑指令',
        addFavorite: '收藏',
        removeFavorite: '取消收藏',
        noResults: '未找到指令',

        // Select Dialog
        selectDialog: {
            title: '从库中选择',
            forSection: '用于章节',
        },

        // Technology Area
        technologyArea: {
            general: '通用',
            electrical: '电气',
            mechanical: '机械',
            chemical: '化学',
            software: '软件',
        },

        // Section
        section: {
            title: '标题',
            background: '背景',
            summary: '发明内容',
            briefFigures: '附图简述',
            claims: '权利要求',
            abstract: '摘要',
            detailed: '详细描述',
            detailedPlan: '详细描述计划',
            repeatClaims: '重复权利要求',
            custom: '自定义',
        },

        // Filter
        filter: {
            title: '筛选',
            region: '地区',
            type: '类型',
            from: '来源',
            myInstructions: '我的指令',
            library: '指令库',
            clear: '清除 {count} 个筛选',
        },

        // Dialog
        dialog: {
            name: '指令名称',
            namePlaceholder: '请输入指令名称',
            instructionType: '指令类型',
            templateSection: '模板章节',
            selectSection: '请选择模板章节',
            description: '描述',
            descriptionPlaceholder: '请输入描述信息 (可选)',
            descriptionHint: '简要描述这条指令的用途和特点',
            content: 'AI 指令内容',
            contentPlaceholder: '请输入 AI 指令内容，这将指导 AI 如何生成内容...',
            contentHint: '详细描述 AI 应该如何处理和生成内容，包括风格、格式、重点等要求',
            advancedSettings: '高级设置',
            region: '地区',
            technologyArea: '技术领域',
            optional: '可选',
            quickSettings: '快速设置',
            requiredFieldsHint: '* 表示必填项',
            fillBasicInfo: '填写基本信息以创建新指令',
            updateHint: '更新指令信息',
            viewOnlyHint: '查看系统指令详情（只读模式）',
            unsavedChangesTitle: '未保存的修改',
            unsavedChangesMessage: '您有未保存的修改，确定要关闭吗？关闭后修改将丢失。',
            discardChanges: '放弃修改',
            continueEditing: '继续编辑',
            systemReadOnlyHint: '系统指令为只读，无法编辑',
            readOnlyPermissionHint: '您只有只读权限，无法编辑此指令',
            close: '关闭',
            dynamicFields: '动态字段',
            noDynamicFields: '未配置动态字段，使用时将直接应用指令内容。',
            addField: '添加字段',
            removeField: '删除',
            untitledField: '未命名字段',
            fieldLabel: '字段名称',
            fieldLabelPlaceholder: '例如：撰写语气',
            fieldType: '字段类型',
            fieldRequired: '是否必填',
            fieldOptionSource: '选项来源',
            fieldDescription: '字段说明',
            fieldDescriptionPlaceholder: '说明这个字段的用途',
            fieldPlaceholder: '占位提示',
            fieldPlaceholderPlaceholder: '请输入字段提示',
            fieldDefault: '默认值',
            fieldDefaultPlaceholder: '请输入默认值',
            fieldOptions: '选项',
            addOption: '添加选项',
            optionLabel: '选项名称',
            optionValue: '选项值',
            yes: '是',
            no: '否',
            none: '无',
            fieldTypes: {
                text: '单行文本',
                textarea: '多行文本',
                number: '数字',
                select: '单选',
                multiSelect: '多选',
                boolean: '开关',
            },
            optionSources: {
                claims: '权利要求',
                figures: '附图',
            },
            defaultField: '默认',

            // Level selection (Super Admin only)
            level: '可见性',
            adminOnly: '仅管理员',
            systemLevel: '系统级',
            userLevel: '用户级',
        },

        defaultFields: {
            labels: {
                word_count: '字数',
                drawing_reference_marks: '附图标记',
                technical_problem: '技术问题',
                technical_effect: '技术效果',
                invention_title: '发明名称',
                two_part_form: '两部式',
                functional_limitation: '功能性限定',
                multiple_dependency: '多重从属',
                use_reference_signs: '使用附图标记',
                markush: '马库什',
                multiple_invention_categories: '多种发明类别',
                max_independent_claims: '独立权利要求最大数量',
                total_claims: '权利要求总数',
                claim_indent_format: '权利要求缩进格式',
                closest_prior_art: '最接近现有技术',
            },
            options: {
                auto: '自动',
                allow: '允许',
                forbid: '禁止',
                none: '无',
                first_line: '首行缩进',
                hanging: '悬挂缩进',
            },
            descriptions: {
                drawingReferenceMarksAbstract: '您定义的附图标记可以包含在摘要中。',
                technicalProblemAbstract: '您定义的技术问题可以包含在摘要中。',
                technicalEffectAbstract: '您定义的技术效果可以包含在摘要中。',
                inventionTitleAbstract: '您定义的发明名称可以包含在摘要中。',
                twoPartForm: '两部式将独立权利要求分为前序部分和特征部分。',
                functionalLimitation: '功能性限定的权利要求引用没有具体定义结构的要素。',
                multipleDependency: '多重从属权利要求是引用多个权利要求的从属权利要求。',
                useReferenceSignsClaims: '您定义的附图标记可以包含在权利要求中。',
                markush: '马库什权利要求在单个权利要求中具有多个排他性替代要素。',
                multipleInventionCategories: '允许在权利要求中使用多种发明类别。',
                closestPriorArt: '您提供的每个现有技术文件将包括在背景技术中。',
            },
        },

        // Tabs
        tabs: {
            all: '全部',
            title: '标题',
            abstract: '摘要',
            background: '背景',
            summary: '发明内容',
            claims: '权利要求',
            detailedDescription: '具体实施方式',
            officeActionResponse: '审查意见答复',
            myInstructions: '我的指令',
            sharedInstructions: '分享的指令',
            favorites: '收藏',
        },

        // Pills
        pills: {
            all: '全部指令',
            my: '我的指令',
            official: '官方指令',
            shared: '分享的指令',
            favorites: '收藏',
        },

        // Sections
        sections: {
            title: '标题',
            abstract: '摘要',
            background: '背景技术',
            technicalField: '技术领域',
            summary: '发明内容',
            briefFigures: '附图说明',
            claims: '权利要求书',
            detailed: '具体实施方式',
            custom: '自定义',
        },

        // Instruction Types
        instructionTypes: {
            patentApplication: '专利申请',
            inventionDisclosure: '发明披露',
            officeActionResponse: '审查意见答复',
        },

        // Sources
        sources: {
            system: '系统',
            custom: '自定义',
            library: '指令库',
        },

        // Messages
        messages: {
            saveFailed: '保存失败',
            fetchListFailed: '获取指令列表失败',
            fetchDetailFailed: '获取指令详情失败',
            createSuccess: '创建成功',
            createFailed: '创建失败',
            updateSuccess: '更新成功',
            updateFailed: '更新失败',
            deleteSuccess: '删除成功',
            deleteFailed: '删除失败',
            addFavoriteSuccess: '收藏成功',
            removeFavoriteSuccess: '取消收藏成功',
            favoriteOperationFailed: '收藏操作失败',
            systemInstructionReadOnly: '系统指令为只读，无法编辑',
            shareSuccess: '分享成功',
            shareFailed: '分享失败',
            fetchSharesFailed: '获取分享列表失败',
            updateShareSuccess: '更新分享成功',
            updateShareFailed: '更新分享失败',
            deleteShareSuccess: '删除分享成功',
            deleteShareFailed: '删除分享失败',
        },

        // Share
        share: {
            title: '分享',
            shareType: '分享类型',
            company: '公司',
            companyShareName: '本公司',
            personal: '个人',
            permission: '权限',
            read: '只读',
            write: '读写',
            sharedTo: '分享给',
            expiresAt: '过期时间',
            neverExpires: '永不过期',
            expiry7Days: '7天',
            expiry15Days: '15天',
            expiry30Days: '30天',
            shareList: '分享列表',
            noShares: '暂无分享记录',
            confirmDelete: '确认删除此分享记录？',
            cannotShareSystem: '系统指令不允许分享',
            cannotShareOthers: '只能分享自己创建的指令',
            enterUserId: '请输入用户ID',
            viewShareList: '查看分享列表',
            createNew: '创建分享',
            companyShareDesc: '公司内所有成员都可以访问此指令',
            personalShareDesc: '仅指定用户可以访问此指令',
        },
    },
};
